module.exports = __webpack_public_path__ + "static/media/soon.57a4b6e6.png";